import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';

const Brands = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    // Define the validation function in the window object
    window.checkMandatory802912000000437337 = function () {
      var mndFileds = ["Company", "Last Name"];
      var fldLangVal = ["Company", "Last Name"];

      // Get the form by ID instead of name
      const form = document.getElementById("webform802912000000437337");

      for (let i = 0; i < mndFileds.length; i++) {
        // Use querySelector to find the input directly
        var fieldObj = form.querySelector(`[name="${mndFileds[i]}"]`);
        if (fieldObj) {
          if (fieldObj.value.trim().length === 0) {
            alert(fldLangVal[i] + " cannot be empty");
            fieldObj.focus();
            return false;
          }
        }
      }

      const submitButton = form.querySelector(".formsubmit");
      if (submitButton) {
        submitButton.setAttribute("disabled", true);
      }
      return true;
    };
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      if (!window.checkMandatory802912000000437337()) {
        return;
      }

      setIsSubmitting(true);
      const formElement = event.target;
      const formData = new FormData(formElement);

      const response = await fetch(formElement.action, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      // Show success message with SweetAlert2
      await Swal.fire({
        icon: 'success',
        title: 'Success!',
        text: 'Your form has been submitted successfully.',
        confirmButtonColor: '#4299e1',
      });

      // Redirect to home page instead of dashboard
      navigate('/');
    } catch (error) {
      console.error('Error submitting form:', error);
      // Show error message with SweetAlert2
      await Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'There was an error submitting the form. Please try again.',
        confirmButtonColor: '#4299e1',
      });
    } finally {
      setIsSubmitting(false);
    }
  };



  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div style={styles.container}>
        <div style={styles.headerContainer}>
          <button onClick={() => navigate(-1)} className="text-gray-600 p-4">
            <FaArrowLeft size={24} />
          </button>
          <h2 style={styles.title}>Brand Space</h2>
        </div>
        <form
          id="webform802912000000437337"
          name="webform802912000000437337"
          action="https://crm.zoho.eu/crm/WebToLeadForm"
          method="POST"
          onSubmit={handleSubmit}
          acceptCharset="UTF-8"
          style={styles.form}
        >
          {/* Hidden Inputs */}
          <input type="hidden" name="xnQsjsdp" value="64722b4e65ac0da7cb828bdb15e95eb0d912c2b08ab1a713ae3b0c787e96e103" />
          <input type="hidden" name="zc_gad" id="zc_gad" value="" />
          <input type="hidden" name="xmIwtLD" value="bfd6a278fdfddd69dbf25ddde5ddc00aa6fc3aa1a05958ad5a757de40254e8c8035badd6e397221d184883564d6c9e18" />
          <input type="hidden" name="actionType" value="TGVhZHM=" />
          <input type="hidden" name="returnURL" value="null" />

          {/* Form Fields */}
          <label style={styles.label}>
            Company <span style={{ color: "red" }}>*</span>
            <input type="text" name="Company" style={styles.input} required />
          </label>

          <label style={styles.label}>
            Last Name <span style={{ color: "red" }}>*</span>
            <input type="text" name="Last Name" style={styles.input} required />
          </label>

          <label style={styles.label}>
            LinkedIn Profile
            <input type="text" name="LEADCF1" style={styles.input} />
          </label>

          <label style={styles.label}>
            Mobile
            <input type="text" name="Mobile" style={styles.input} />
          </label>

          <label style={styles.label}>
            Country
            <input type="text" name="Country" style={styles.input} />
          </label>

          {/* Buttons */}
          <div style={styles.buttonContainer}>
            <button
              type="submit"
              className="formsubmit"
              style={styles.submitButton}
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Submitting...' : 'Submit'}
            </button>
            <button type="reset" style={styles.resetButton}>
              Reset
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

// Styling
const styles = {
  container: {
    backgroundColor: "#fff",
    color: "#333",
    maxWidth: "600px",
    margin: "20px auto",
    padding: "30px",
    borderRadius: "12px",
    boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
    fontFamily: "Inter, system-ui, sans-serif",
  },
  headerContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: "30px",
    gap: "20px",
  },
  title: {
    fontSize: "28px",
    fontWeight: "600",
    color: "#2d3748",
    flex: 1,
    textAlign: "center",
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    marginBottom: "15px",
    fontWeight: "500",
    display: "flex",
    flexDirection: "column",
    color: "#4a5568",
  },
  input: {
    padding: "12px",
    fontSize: "16px",
    borderRadius: "8px",
    border: "1px solid #e2e8f0",
    marginTop: "6px",
    transition: "border-color 0.2s",
    outline: "none",
    "&:focus": {
      borderColor: "#4299e1",
      boxShadow: "0 0 0 3px rgba(66, 153, 225, 0.1)",
    },
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "30px",
    gap: "15px",
  },
  submitButton: {
    backgroundColor: "#4299e1",
    color: "white",
    padding: "12px 24px",
    fontSize: "16px",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "background-color 0.2s",
    "&:hover": {
      backgroundColor: "#3182ce",
    },
    flex: 1,
  },
  resetButton: {
    backgroundColor: "#fff",
    color: "#e53e3e",
    padding: "12px 24px",
    fontSize: "16px",
    border: "2px solid #e53e3e",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.2s",
    "&:hover": {
      backgroundColor: "#e53e3e",
      color: "#fff",
    },
    flex: 1,
  },
};

export default Brands;


